/**
 * Created by admin on 2018/5/22.
 */
import React, { PureComponent } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Input, Modal } from 'antd';
import './AuditRejectModal.less';
import { Btn } from '../Widgets';

const { TextArea } = Input;

class AuditRejectModal extends PureComponent {
  static defaultProps = {
    visible: false
  };

  constructor(props) {
    super(props);
    this.state = {
      remark: ''
    };
  }

  render() {
    const { visible, intl } = this.props;
    const { remark } = this.state;
    return (
      <Modal
        destroyOnClose={true}
        visible={visible}
        onCancel={this.close}
        title={<FormattedMessage id="audit_reject_reason" />}
        wrapClassName="modal-close-header reject-reason-wrapper"
        width={600}
        footer={
          <div className="edit-footer">
            <Btn primary onClick={this.submit}>
              提交
            </Btn>
          </div>
        }
        closable
      >
        <div className="reject-reason">
          <span className="pre">
            <FormattedMessage id="audit_reject_reason_pre" />
          </span>
          <TextArea
            placeholder={intl.formatMessage({ id: 'audit_reject_tip' })}
            value={remark}
            autosize={{ minRows: 4, maxRows: 8 }}
            onChange={e => {
              this.setState({ remark: e.target.value });
            }}
          />
        </div>
      </Modal>
    );
  }

  close = () => {
    const { onClose } = this.props;
    onClose && onClose();
  };
  submit = () => {
    const { onClose, onSubmit } = this.props;
    const { remark } = this.state;
    onSubmit && onSubmit(remark);
    onClose && onClose();
  };
}

export default injectIntl(AuditRejectModal);



// WEBPACK FOOTER //
// ./src/components/AuditManage/AuditRejectModal.js